<template>
  <div>
    <b-card
      no-body
      class="mb-0"
    >
      <div class="m-2">
        <!-- Table Top -->
        <b-row>
          <b-col
            cols="12"
            md="4"
            lg="2"
          >
            <div>
              <p class="mr-1">
                Exibir empresa Imediato?
              </p>
            </div>
            <b-form-checkbox
              :checked="showImediato"
              class="custom-control-secondary"
              name="check-button"
              switch
              @input="showImediato = !showImediato;"
            >
              <span class="switch-icon-left">
                <feather-icon icon="CheckIcon" />
              </span>
              <span class="switch-icon-right">
                <feather-icon icon="XIcon" />
              </span>
            </b-form-checkbox>
          </b-col>
          <b-col
            cols="12"
            md="4"
            lg="2"
          >
            <b-form-group
              class=""
              label="Data de início"
              label-for="start-date"
            >
              <flat-pickr
                v-model="startDate"
                if="start-date"
                class="form-control input-date"
                :config="configDate"
              />
            </b-form-group>
          </b-col>
          <b-col
            cols="12"
            md="4"
            lg="2"
          >
            <b-form-group
              class=""
              label="Data fim"
              label-for="end-date"
            >
              <flat-pickr
                v-model="endDate"
                if="end-date"
                class="form-control input-date"
                :config="configDate"
              />
            </b-form-group>
          </b-col>
          <b-col
            cols="12"
            md="6"
            lg="3"
          >
            <label for="institution-id">Instituição</label>
            <v-select
              id="institution-id"
              v-model="institutionId"
              name="institution-id"
              :options="institutionOptions"
              label="label"
              item-value="value"
              item-text="label"
              @input="fetchWorkplaces"
            >
              <span slot="no-options">Nenhuma instituição encontrada.</span>
            </v-select>
          </b-col>
          <b-col
            cols="12"
            md="6"
            lg="3"
          >
            <div class="d-flex flex-grow-1 align-items-end justify-content-end mt-2 mx-2">
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="primary"
                class="btn-icon mr-1 text-nowrap"
                @click="refetchData"
              >
                Buscar
                <feather-icon
                  icon="SearchIcon"
                  size="16"
                />
              </b-button>
              <b-button
                class="ml-1"
                variant="primary"
                :disabled="exporting"
                @click="downloadReport"
              >
                <span class="text-nowrap">
                  Exportar
                </span>
              </b-button>
            </div>
          </b-col>
        </b-row>
      </div>

      <b-table
        ref="refUserListTable"
        style="min-height: 70vh"
        :sticky-header="true"
        class="position-relative"
        :items="myList"
        responsive
        :fields="tableColumns"
        primary-key="id"
        show-empty
        sortable
        empty-text="Nenhum registro correspondente encontrado"
      >
        <template
          #cell(ratio)="{ item }"
          class="w-100"
        >
          <div
            v-if="item.status_color === 'green'"
            class="text-success"
          >
            {{ item.ratio }}
          </div>
          <div
            v-if="item.status_color === 'red'"
            class="text-danger"
          >
            {{ item.ratio }}
          </div>
          <div
            v-if="item.status_color === 'yellow'"
            class="text-warning"
          >
            {{ item.ratio }}
          </div>
        </template>
      </b-table>
    </b-card>
  </div>
</template>

<script>
import {
  BCard, BRow, BCol, BTable, BButton, BFormGroup, BFormCheckbox,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import store from '@/store'
import { ref } from '@vue/composition-api'
import { avatarText } from '@core/utils/filter'
import flatPickr from 'vue-flatpickr-component'
import {
  formatCurrency, formatDateTimeDDMMYYHHMM, formatDateTimeDDMMYYYY, pad,
} from '@core/utils/utils'
import vSelect from 'vue-select'
import { Portuguese } from 'flatpickr/dist/l10n/pt'
import useReportLaunchedVsConfirmed from './useReportLaunchedVsConfirmed'
import contractStoreModule from '../reportStoreModule'

export default {
  components: {
    BFormCheckbox,
    BCard,
    BRow,
    BCol,
    BTable,
    BButton,
    BFormGroup,
    vSelect,
    flatPickr,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      configDate: {
        enableTime: true,
        dateFormat: 'd/m/Y H:i',
        locale: Portuguese,
        time_24hr: true,
        defaultHour: 0,
        defaultMinute: 0,
      },
    }
  },
  setup() {
    const STORE_MODULE_NAME = 'app-reports'

    // Register module
    if (!store.hasModule(STORE_MODULE_NAME)) store.registerModule(STORE_MODULE_NAME, contractStoreModule)

    const invoiceModal = ref(null)
    const invoiceBatchLiquidateModal = ref(null)
    const invoiceReopenModal = ref(null)
    const reopenReason = ref(null)
    const paymentDate = ref('')
    const loading = ref(false)
    const currentUserId = ref(null)
    const paymentRemittanceModal = ref(null)
    const paymentRemittance = ref(null)

    const {
      downloadReport,
      exporting,
      getItems,
      fetchInstitutions,
      tableColumns,
      perPage,
      currentPage,
      totalItems,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refUserListTable,
      refetchData,

      // UI
      resolveUserRoleVariant,
      resolveUserRoleIcon,
      resolveDeadlineVariant,
      myList,

      // Extra Filters
      createPaymentRemittance,
      institutionId,
      workplaceId,
      institutionOptions,
      workplaceOptions,
      fetchWorkplaces,

      startDate,
      endDate,
      showImediato,

    } = useReportLaunchedVsConfirmed()

    fetchInstitutions()
    refetchData()

    return {
      showImediato,
      myList,
      invoiceBatchLiquidateModal,
      downloadReport,
      exporting,
      workplaceOptions,
      fetchWorkplaces,
      loading,
      startDate,
      endDate,

      getItems,
      tableColumns,
      perPage,
      currentPage,
      totalItems,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refUserListTable,
      refetchData,
      paymentDate,
      // Filter
      avatarText,

      // UI
      resolveUserRoleVariant,
      resolveUserRoleIcon,
      resolveDeadlineVariant,

      currentUserId,
      invoiceModal,
      invoiceReopenModal,

      // Extra Filters
      formatCurrency,
      formatDateTimeDDMMYYHHMM,
      formatDateTimeDDMMYYYY,
      createPaymentRemittance,
      paymentRemittanceModal,
      paymentRemittance,
      institutionId,
      institutionOptions,
      workplaceId,
      reopenReason,
      pad,
    }
  },
}
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}
.dates-row {
  max-width: 500px;
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-flatpicker.scss';
@import '@core/scss/vue/libs/vue-select.scss';
tr:has(.custom-checkbox.checked) {
  background-color: rgba(98, 98, 98, 0.05);
}

.table-responsive {
  min-height: 200px;
}
.invoice-date {
  margin-top: 2px;
  font-size: 0.757rem;
  font-weight: 400;
  line-height: 0.857rem;
  div {
    font-size: 0.957rem;
    line-height: 0.757rem;
  }
}
h5 {
  margin-bottom: 0;
}
.icon-status {
  margin-top: -4px;
}
</style>
